import { Component } from '@angular/core';
import Chart from 'chart.js/auto';
import { User } from '../models/user';
import { AuthService } from '../services/authService';

@Component({
    selector: 'app-goals-chart',
    templateUrl: './goals-chart.component.html',
    styleUrl: './Goals-chart.component.scss',
    standalone: false
})
export class GoalsChartComponent {
  public chart: any;
  user = new User('', false);

  constructor(private authService: AuthService) { }

  async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();
    this.createChart();
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? "";
        resolve(this.user.loggedin);
      });
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  createChart() {
    this.chart = new Chart('goalsPieChart', {
      type: 'pie', //this denotes tha type of chart

      data: {
        // values on X-Axis
        labels: ['Carbs', 'Fat', 'Protein', 'Alcohol'],
        datasets: [
          {
            label: 'Percent',
            data: [10, 15, 70, 5],
            backgroundColor: ['green', 'orange', 'purple', 'gray'],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        aspectRatio: 2.5,
      },
    });
  }
}
